import { Input } from "@getgreenline/blaze-ui";
import { cn } from "@getgreenline/blaze-ui";
import { FormFieldLabel } from "./form-field-label";

type BudgetDateInputProps = {
  label: string;
  name: string;
  value: string;
  min?: string;
  max?: string;
  invalid?: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
};

export function BudgetDateInput({
  label,
  name,
  value,
  min,
  max,
  invalid = false,
  onChange,
}: BudgetDateInputProps) {
  return (
    <label className="tw:block">
      <FormFieldLabel>{label}</FormFieldLabel>
      <Input
        type="date"
        name={name}
        value={value}
        onChange={onChange}
        min={min}
        max={max}
        aria-label={label}
        aria-invalid={invalid}
        className={cn(
          "tw:pr-10 tw:placeholder:text-muted-foreground/50",
          invalid &&
            "tw:border-destructive focus-visible:tw:ring-destructive/20",
        )}
      />
    </label>
  );
}
